import { SUPPORT_CONTACTS } from '../../utils/constants'

export const ERRORMESSAGES = {
  password: 'Password must be at least 8 characters long and contain a special character (!@#$%^&*), number, uppercase and lowercase letter.',
  passwordMatch: 'The passwords you entered do not match.',
  bigYikes: `There was a problem creating your account. Try again or contact ${SUPPORT_CONTACTS.email.toLowerCase()}.`
}
